export default "__VITE_ASSET__ukKMMFkr__"